import { Box } from '@mui/material';
import { TextUIPart } from 'ai';
import { SparklesIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { Streamdown } from 'streamdown';

import { components, allowedTags } from '../../../ChatMessage/MessageRenderer/MessageRenderer.config';
import { ChatUserMessageProps } from '../../ChatUserMessage';

export const ChatSuggestionMessage = ({ message }: ChatUserMessageProps): ReactNode => {
  const parts = message.parts as TextUIPart[];
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[200],
        padding: 3,
        borderRadius: 2,
        alignSelf: 'flex-end',
        position: 'relative',
      })}
    >
      <Box
        position="absolute"
        top={-10}
        left={-10}
        width={20}
        height={20}
        borderRadius="50%"
        sx={(theme) => ({ backgroundColor: theme.palette.text.primary })}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <SparklesIcon fill="white" width={14} height={14} stroke="white" />
      </Box>
      <Box sx={{ maxWidth: 'md' }}>
        <Streamdown mode="static" components={components} allowedTags={allowedTags}>
          {parts[0].text}
        </Streamdown>
      </Box>
    </Box>
  );
};
